import { render, staticRenderFns } from "./NewSession.vue?vue&type=template&id=5ee2c08e&scoped=true&"
import script from "./NewSession.vue?vue&type=script&lang=js&"
export * from "./NewSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee2c08e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VTimelineItem})
